<template>
  <div class="nch--blog">
    <aside class="nch--blog-aside">
      <Share v-if="post" :post="post" />
      <Categories />
    </aside>
  </div>
</template>
<script>
import Share from './Share';
import Categories from './Categories';

export default {
  name: 'Aside',
  components: {
    Share,
    Categories,
  },
  props: {
    post: {
      type: Object,
      required: false,
    },
  },
};
</script>
<style scoped>
.nch--blog-aside{
  display: flex;
  flex-direction: column;
  min-width: 300px;
  display: flex;
  position: sticky;
  top: 40px;
}
</style>
